export enum PermRoleKey {
  Admin = 'admin', // 管理员
  Cce = 'cce', // 认证
  Developer = 'developer', // 研发
  Dqe = 'dqe', // QPM
  Finance = 'finance', // 财务
  Fqc = 'fqc', // FQC
  Ipqc = 'ipqc', // IPQC
  Iqc = 'iqc', // IQC
  Leader = 'leader', // 管理者
  Npi = 'npi', // NPI
  Op = 'op', // 运营
  Oqc = 'oqc', // OQC
  Pie = 'pie', // PIE
  Pm = 'pm', // 项目经理
  Pqe = 'pqe', // PQE
  Product = 'product', // 产品经理
  Pt = 'pt', // 生产测试
  Ptest = 'ptest', // 生产测试开发
  Sale = 'sale', // 售后
  Sqe = 'sqe', // SQE
  Supply = 'supply', // 供应链
  SupplyMgr = 'supply-mgr', // 生产主管
  Tester = 'tester', // 测试
  Ui = 'ui', // UI设计
  Pmc = 'pmc', // 计划工程师
  Buyer = 'buyer',
  Cqe = 'cqe',
  TestOd = 'test-od', // 测试外包
  DevOd = 'dev-od', // 研发外包
  Store = 'store', // 仓储
  Wmp = 'wmp', // 整机工艺
  Audit = 'audit', // 内审监察
  TestSe = 'test-se', // 测试SE
  SystemArchitect = 'system-architect', // 系统架构师
}

export const PermRoleTranslateMap: { [key: string]: string } = {
  'admin': '管理员',
  'cce': '认证',
  'developer': '研发',
  'finance': '财务',
  'fqc': 'fqc',
  'ipqc': 'ipqc',
  'iqc': 'iqc',
  'leader': '管理者',
  'npi': 'npi',
  'op': '运营',
  'pie': 'pie',
  'pm': '项目经理',
  'pqe': 'pqe',
  'product': '产品经理',
  'pt': '生产测试',
  'ptest': '生产测试开发',
  'sale': '售后',
  'sqe': 'sqe',
  'supply': '生产拉长',
  'supply-mgr': '生产主管',
  'tester': '测试',
  'ui': 'UI设计',
  'pmc': '计划工程师',
  'buyer': '采购',
  'cqe': 'cqe',
  'test-od': '测试外包',
  'dev-od': '研发外包',
  'store': '仓储',
  'wmp': '整机工艺',
  'audit': '内审监察',
  'test-se': '测试SE',
  'system-architect': '系统架构师',
};
